import Vue from 'vue'
import { parseTime } from '@/utils/index'

const filters = {
  timeTransform (val) {
    return val === null ? null : parseTime(val, '{y}-{m}-{d} {h}:{i}:{s}')
  }
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

export default filters
